module.exports = __webpack_public_path__ + "static/media/Tile1.6ffcec42.png";